import AMapLoader from '@amap/amap-jsapi-loader'

const AMAP_KEY = process.env.VUE_APP_AMAP_KEY
const AMAP_SECURITY_CODE =
  process.env.VUE_APP_AMAP_SECURITY_CODE

const DEFAULT_PLUGINS = [
  'AMap.Geolocation',
  'AMap.CitySearch',
  'AMap.Geocoder'
]

let amapInstance = null
let amapLoadingPromise = null

// 初始化高德地图（单例模式）
export const initAMap = async (options = {}) => {
  if (amapInstance) {
    return Promise.resolve(amapInstance)
  }

  if (amapLoadingPromise) {
    return amapLoadingPromise
  }

  window._AMapSecurityConfig = {
    securityJsCode: AMAP_SECURITY_CODE
  }

  amapLoadingPromise = AMapLoader.load({
    key: AMAP_KEY,
    version: '2.0',
    plugins: options.plugins || DEFAULT_PLUGINS
  })
    .then(AMap => {
      amapInstance = AMap
      return AMap
    })
    .catch(err => {
      amapLoadingPromise = null
      throw err
    })

  return amapLoadingPromise
}

// 获取高德地图实例
export function getAMap() {
  return initAMap()
}
